<template>
  <div>
    <div class="head-container">
      <img src="@/assets/images/icon/icon-menu.svg" />
      <p>{{ $t('안전보건관리 구축 및 이행 현황') }}</p>
    </div>
    <div class="title-container">
      <p>{{ $t(`${companyName}`) }}</p>
      <vs-select v-model="year" autocomplete style="width: 100px">
        <vs-select-item v-for="_year in years" :key="_year" :value="_year" :text="`${_year}년`" />
      </vs-select>
    </div>
    <ul>
      <li>
        <span style="background-color: #fdde05"></span>
        <div>
          <p>{{ $t('안전보건 경영방침') }}</p>
          <p>{{ list.안전보건경영방침 }}</p>
        </div>
      </li>
      <li>
        <span style="background-color: #fb9d21"></span>
        <div>
          <p>{{ $t('안전보건 추진 목표') }}</p>
          <p>{{ list.안전보건추진목표 }}</p>
        </div>
      </li>
      <li>
        <span style="background-color: #ec4125"></span>
        <div>
          <p>{{ $t('안전보건 조직도(변경)') }}</p>
          <p>{{ list.안전보건조직도 | comma }}회</p>
        </div>
      </li>
      <li>
        <span style="background-color: #c32429"></span>
        <div>
          <p>{{ $t('유해·위험 기계·기구 설비(인증대상)') }}</p>
          <p>{{ list.유해위험기계기구설비 | comma }}건</p>
        </div>
      </li>
      <li>
        <span style="background-color: #fccdc7"></span>
        <div>
          <p>{{ $t('유해·위험요인 파악(인증대상 외)') }}</p>
          <p>{{ list.유해위험요인파악 | comma }}건</p>
        </div>
      </li>
      <li>
        <span style="background-color: #f9aac7"></span>
        <div>
          <p>{{ $t('정기 위험성평가') }}</p>
          <p>{{ list.정기위험성평가 | comma }}건</p>
        </div>
      </li>
      <!--       차후적용
      <li>
        <span style="background-color: #e03f85"></span>
        <div>
          <p>{{ $t('개선조치현황') }}</p>
          <p>{{ list.개선조치현황 | comma }}건</p>
        </div>
      </li> -->
      <li>
        <span style="background-color: #9e3393"></span>
        <div>
          <p>{{ $t('3등급(상·중·하) 판단법') }}</p>
          <p>{{ list["3등급판단법"] | comma }}건</p>
        </div>
      </li>
      <li>
        <span style="background-color: #691d5b"></span>
        <div>
          <p>{{ $t('주간 이행사항 점검 및 회의') }}</p>
          <p>{{ list.주간이행사항점검및회의 | comma }}건</p>
        </div>
      </li>
      <li>
        <span style="background-color: #4b8fcc"></span>
        <div>
          <p>{{ $t('일일TBM 활동') }}</p>
          <p>{{ list.일일TBM활동 | comma }}건</p>
        </div>
      </li>
      <li>
        <span style="background-color: #a7ddf5"></span>
        <div>
          <p>{{ $t('예산 편성액') }}</p>
          <p>{{ list.예산편성액 | comma }}만원</p>
        </div>
      </li>
      <li>
        <span style="background-color: #56c5cd"></span>
        <div>
          <p>{{ $t('예산 집행액') }}</p>
          <p>{{ list.예산집행액 | comma }}만원</p>
        </div>
      </li>
      <li>
        <span style="background-color: #169876"></span>
        <div>
          <p>{{ $t('안전보건 교육 현황') }}</p>
          <p>{{ list.안전보건교육현황 | comma }}건</p>
        </div>
      </li>
      <li>
        <span style="background-color: #1c592f"></span>
        <div>
          <p>{{ $t('안전보건 점검 현황') }}</p>
          <p>{{ list.안전보건점검현황 | comma }}건</p>
        </div>
      </li>
      <li>
        <span style="background-color: #96ca41"></span>
        <div>
          <p>{{ $t('사고발생 현황') }}</p>
          <p>{{ list.사고발생현황 | comma }}건</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  filters: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    const nowYear = new Date().getFullYear();
    return {
      nowYear,
      years: Array.from({ length: nowYear - 2024 + 1 }, (_, i) => nowYear - i),
      year: nowYear,

      list: {
        "안전보건경영방침": "",
        "안전보건추진목표": "",
        "안전보건조직도": "",
        "유해위험기계기구설비": "",
        "유해위험요인파악": "",
        "정기위험성평가": "",
        "개선조치현황": "",
        "3등급판단법": "",
        "주간이행사항점검및회의": "",
        "일일TBM활동": "",
        "예산편성액": "",
        "예산집행액": "",
        "안전보건교육현황": "",
        "안전보건점검현황": "",
        "사고발생현황": "",
      },
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    companyName() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (!memberInfo || !memberInfo.company) return '';
      return memberInfo.company.com_name || '';
    },
  },
  watch: {
    year() {
      this.$emit("changeYear", this.year);

      this.list = {
        "안전보건경영방침": "",
        "안전보건추진목표": "",
        "안전보건조직도": "",
        "유해위험기계기구설비": "",
        "유해위험요인파악": "",
        "정기위험성평가": "",
        "개선조치현황": "",
        "3등급판단법": "",
        "주간이행사항점검및회의": "",
        "일일TBM활동": "",
        "예산편성액": "",
        "예산집행액": "",
        "안전보건교육현황": "",
        "안전보건점검현황": "",
        "사고발생현황": "",
      };

      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      // post 데이터가 필요한 id
      const withBoardIdsP = {
        // 유해·위험 기계·기구 설비(인증대상)
        "668_1": [
          {
            key: "body.riskAppraisalList[%].input_5",
            operator: "!=",
            value: "해당없음",
          },
        ],
        //  유해･위험요인 파악 (인증대상 외)
        "688_2": [
          {
            key: "body.riskAppraisalList[%].input_5",
            operator: "IN",
            value: ["해당없음", null, ""],
          },
        ],

        "1071": [], // 예산 편성액 / 예산 집행액
      };

      const withBoardCountIds = [
        495, // 안전보건 경영방침
        1070, // 안전보건 추진 목표
        // ====== 안전보건 조직도(변경) =======
        453,
        698,
        // =============================
        // ====== 정기 위험성평가 =======
        161,
        690,
        // =============================
        // 개선조치현황 (차후적용)
        475, // 3등급(상·중·하) 판단법
        476, // 주간 이행사항 점검 및 회의
        477, // 일일TBM 활동
        434, // 안전보건 교육 현황
        // ====== 안전보건 점검 현황 =======
        289,
        668,
        697,
        721,
        693,
        214,
        200,
        447,
        // ================================
        117, // 사고발생 현황
      ];

      //  =============================== LOAD DATA =======================================
      const postPromises = Object.entries(withBoardIdsP).map(async ([element, payload]) => {
        const data = await this.loadPosts(element.split("_")[0], payload);
        return [`p:${  element}`, data]; // 구분용 prefix
      });

      const countPromise = this.loadPostCount(withBoardCountIds).then((data) => ["count", data]);

      const allResults = await Promise.all([...postPromises, countPromise]);

      // 결과 정리
      const bDatas = {};
      const pDatas = {};
      let countDatas = null;

      allResults.forEach(([key, data]) => {
        if (key.startsWith("b:")) {
          bDatas[key.slice(2)] = data;
        } else if (key.startsWith("p:")) {
          pDatas[key.slice(2)] = data;
        } else if (key === "count") {
          countDatas = data;
        }
      });
      //  =============================== LOAD DATA =======================================

      //  안전보건경영방침
      this.list.안전보건경영방침 = 0 < countDatas[495] ? "작성" : "미작성";

      //  안전보건 추진 목표
      this.list.안전보건추진목표 = 0 < countDatas[1070] ? "작성" : "미작성";

      // 안전보건 조직도(변경)
      this.list.안전보건조직도 = countDatas[453] + countDatas[698];

      // 유해·위험 기계·기구 설비(인증대상)
      this.list.유해위험기계기구설비 = pDatas["668_1"].total;

      // 유해･위험요인 파악(인증대상 외)
      this.list.유해위험요인파악 = pDatas["688_2"].total;

      // 정기 위험성평가
      this.list.정기위험성평가 = countDatas[161] + countDatas[690];

      // 3등급(상·중·하) 판단법
      this.list["3등급판단법"] = countDatas[475];

      // 주간 이행사항 점검 및 회의
      this.list.주간이행사항점검및회의 = countDatas[476];

      // 일일TBM 활동
      this.list.일일TBM활동 = countDatas[477];

      // ================= 예산 편성/집행액 =======================
      let tempData;
      if (0 < pDatas[1071].data.length) {
        tempData = JSON.parse(pDatas[1071].data[0].post_content).body;
        // 예산 편성액
        this.list.예산편성액 = tempData.total.value1;
        // 예산 집행액
        this.list.예산집행액 = tempData.total.value2;
      } else {
        this.list.예산편성액 = 0;
        this.list.예산집행액 = 0;
      }
      // ========================================================

      // 안전보건 교육 현황
      this.list.안전보건교육현황 = countDatas[434];

      // 안전보건 점검 현황
      this.list.안전보건점검현황 = countDatas[289] + countDatas[668] + countDatas[697] + countDatas[721] + countDatas[693] + countDatas[214] + countDatas[200] + countDatas[447];

      // 사고발생 현황
      this.list.사고발생현황 = countDatas[117];
    },

    async loadPosts(boardId, _conditions) {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 1;

      let conditions = [
        { key: "created_at", operator: ">=", value: `${this.year}-01-01` },
        { key: "created_at", operator: "<", value: `${this.year + 1}-01-01` },
      ];
      if (_conditions) conditions = [conditions, ..._conditions];

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions,
      });

      return response;
    },
    async loadPostCount(boardIds) {
      const projectId = this.projectId;

      const response = await this.$store.dispatch("board/LOAD_POST_LIST_COUNT", {
        projectId,
        boardIds, // Number, Array
        dateFrom: `${this.year}-01-01`,
        dateTo: `${this.year}-12-31`,
      });
      const returnData = {};
      response.boards.map((item) => {
        returnData[item.board_id] = item.count;
      });

      return returnData;
    },
  },
};
</script>

<style lang="scss" scoped>
.head-container {
  display: flex;
  align-items: center;

  border: solid 1px #cdcdcd;
  border-radius: 5px;
  margin-bottom: 24px;
  overflow: hidden;

  img {
    background-color: #1e0d61;
    padding: 12px;
  }

  p {
    font-weight: 700;
    font-size: 18px;

    padding: 0 16px;
    margin-bottom: 2px;
  }
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: solid 1px #cdcdcd;
  padding: 5px 0;
  margin-bottom: 14px;

  p {
    font-weight: 500;
    font-size: 16px;
  }
}

/* 리스트 */
ul {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    font-weight: 400;
    font-size: 16px;

    margin-bottom: 10px;

    span {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 8px;
      border-radius: 2px;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: space-between;

      width: 100%;
    }
  }
}
</style>
